// src/api/eventScope.ts
import { AxiosInstance } from 'axios'

/** Chave onde o evento em operação fica guardado neste dispositivo. */
const CHAVE_EVENTO = 'eventUid'

/** Teto de espera: numa rede de centro de eventos, requisição pendurada trava a fila. */
export const TIMEOUT_MS = 8000

export function getEventUid(): string | null {
  try {
    return localStorage.getItem(CHAVE_EVENTO)
  } catch {
    return null
  }
}

export function setEventUid(uid: string): void {
  try {
    localStorage.setItem(CHAVE_EVENTO, uid)
  } catch {
    /* modo privado: segue sem persistir */
  }
}

/**
 * Anexa o escopo de evento e o timeout a todas as chamadas do cliente axios.
 *
 * Este app conversa com a API por axios, que usa XMLHttpRequest — o envelope sobre
 * `window.fetch` não o alcança. Um interceptor no próprio cliente cobre as chamadas
 * existentes sem tocar em nenhuma delas, que é o que permite fazer isso com segurança
 * às vésperas do evento.
 */
export function instalarEscopoDeEvento(api: AxiosInstance): void {
  api.defaults.timeout = TIMEOUT_MS

  api.interceptors.request.use(config => {
    const uid = getEventUid()
    if (uid) {
      config.headers = config.headers || {}
      if (!(config.headers as any)['X-Event-Uid']) {
        ;(config.headers as any)['X-Event-Uid'] = uid
      }
    }
    return config
  })
}

/** Mensagem pronta para a tela, distinguindo falta de rede de recusa do servidor. */
export function mensagemDeErro(e: any): { titulo: string; descricao: string } {
  if (e?.code === 'ECONNABORTED') {
    return { titulo: 'Sem resposta', descricao: 'O servidor demorou. Tente novamente.' }
  }
  if (!e?.response) {
    return { titulo: 'Sem conexão', descricao: 'Verifique o wifi e tente novamente.' }
  }
  const status = e.response.status
  if (status === 404) {
    return { titulo: 'Não encontrado', descricao: 'Não localizamos esse cadastro neste evento.' }
  }
  if (status === 409) {
    return { titulo: 'Já cadastrado', descricao: e.response.data?.message || 'Registro duplicado.' }
  }
  return {
    titulo: 'Erro do servidor',
    descricao: e.response.data?.message || `Código ${status}.`,
  }
}
